import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    dsn: "https://d308676ef78d4de3a8e793e44ac6eb24@o141913.ingest.sentry.io/5581045",
    release: "exceed-meeting-scheduler@" + process.env.npm_package_version,
    autoSessionTracking: true,
    environment: (process.env.REACT_APP_API_BASE_ROUTE.split("//")[1]),
    integrations: [
        new Integrations.BrowserTracing(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    // tracesSampleRate: 1.0,
});

ReactDOM.render(
    <React.StrictMode>
        <React.Fragment><App/></React.Fragment>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
